module.exports = __webpack_public_path__ + "media/src/application/media/img-commerc-edef230258a6b75129d60a428ca8e744.jpg";